"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityFilterValues = exports.entityFilterArgs = void 0;
var sprintf_js_1 = require("sprintf-js");
var lodash_1 = require("lodash");
var to_array_1 = require("./to-array");
var entityFilterArgs = function (args) {
  var context = args.context,
    entityTypeName = args.entityTypeName,
    label = args.label,
    placeholder = args.placeholder,
    name = args.name;
  var entities = context.entities,
    values = context.values,
    t = context.t;
  var isMulti = args.isMulti === undefined ? true : args.isMulti;
  var selectEntityDefinition = entityTypeName && entities[entityTypeName];
  return __assign(__assign({}, args), {
    value: values[name] || [],
    isMulti: isMulti,
    label: label || selectEntityDefinition && (isMulti ? selectEntityDefinition.pluralLabel : selectEntityDefinition.label) || t('Filter'),
    placeholder: placeholder || selectEntityDefinition && (isMulti ? (0, sprintf_js_1.sprintf)(t("Select %s"), selectEntityDefinition.pluralLabel) : (0, sprintf_js_1.sprintf)(t("Select %s"), selectEntityDefinition.aLabel))
  });
};
exports.entityFilterArgs = entityFilterArgs;
var entityFilterValues = function (state) {
  var _a = state.filter,
    filter = _a === void 0 ? {} : _a;
  return (0, lodash_1.mapValues)(filter, function (filterValue) {
    return (0, to_array_1.toArray)(filterValue && filterValue.in);
  });
};
exports.entityFilterValues = entityFilterValues;